export * from './dlg-decoration.component';
